import internal = require('assert');
import { AutocompleteComponent, IAutocompleteOptions } from '../classes/autocomplete';

export function initPolicySearchAutocomplete() {
    var inputs = document.querySelectorAll("[data-policy-search-autocomplete-input]");
    [].forEach.call(inputs, (input) => {
        const autocompleteId = input.id;
        const autocompleteContainer = document.querySelector(`[data-policy-search-autocomplete-results="${autocompleteId}"]`) as HTMLElement;

        new PolicySearchAutocomplete(input, autocompleteContainer);
    });
}
export class PolicySearchAutocomplete {
    readonly AutocompleteSize = 3;
    readonly ActiveClass = 'active';
    readonly AutocompleteItemAttribute = 'data-autocomplete-item';

    _input: HTMLInputElement;
    _submitBtn: HTMLButtonElement;
    _autocompleteContainer: HTMLElement;
    _lastSearchedTerm: string;
    uniqueId: string;
    pageId: number;

    constructor(input: HTMLInputElement, autocompleteContainer: HTMLElement) {
        this._input = input;
        this.uniqueId = input.id;
        this._submitBtn = document.querySelector(`[data-policy-search-autocomplete-submit="${this.uniqueId}"]`) as HTMLButtonElement;
        this._autocompleteContainer = autocompleteContainer;
        this._lastSearchedTerm = '';
        this.pageId = parseInt(autocompleteContainer.getAttribute('data-search-id'));
        this.initialize();
    }

    initialize = () => {
        const panel = document.querySelector(`[data-policy-search-autocomplete-panel="${this.uniqueId}"]`) as HTMLElement;
        const form = document.querySelector(`[data-policy-search-autocomplete-form="${this.uniqueId}"]`) as HTMLFormElement;
        const autocompleteOptions: IAutocompleteOptions = {
            input: this._input,
            panelContainer: panel,
            resultsContainer: this._autocompleteContainer,
            blockContainer: form.parentElement,
            keys: ["displayName"],
            autocompleteSelector: `#${this.uniqueId}`,
            autocompleteResultsSelector: `[data-policy-search-autocomplete-results="${this.uniqueId}"]`,
            resultFormat: (data, source) => {
                source.innerHTML = this.generatePageLink(data["value"]["displayName"], data["value"]["contentId"]);
                source.setAttribute('class', 'autocomplete-result');
            },
            sortFunction: (a, b) => {
                return a["value"]["displayName"].localeCompare(b["value"]["displayName"]);
            },
            dataSrc: async () => {
                this._lastSearchedTerm = this._input.value;
                if (this._lastSearchedTerm?.length >= 3) {
                    const source = await fetch(this.getAutocompleteUrl(this.pageId));
                    const data = await source.json();
                    console.log({data});
                    return data;
                }
            },
            cache: false,
            clickCallback: (target) => {
                if (target.hasAttribute('data-query')) {
                    //this._input.value = target.getAttribute('data-query');
                    //form.submit();
                }
            },
            //closeButton: this._xBtn,
            uniqueId: this.uniqueId,
            noResultsMsg: '<button type="submit" class="un-button hyperlink autocomplete-result-link titling">Search "<strong>{{term}}</strong>"</button>'
        }
        new AutocompleteComponent(autocompleteOptions);

        form.addEventListener('submit', (e) => {
            if (this._input.value == '') {
                e.preventDefault();
            }
        });

        this._input.addEventListener('keyup', this.checkSubmit.bind(this));
        this._input.addEventListener('change', this.checkSubmit.bind(this));
    }

    checkSubmit() {
        if (this._input.value == '') {
            this._submitBtn.setAttribute('disabled', '');
        }
        else {
            this._submitBtn.removeAttribute('disabled');
        }
    }

    getAutocompleteUrl(pageId: number) {
        return `/api/contentscategorysearch/autocompletelist/${this.pageId}`;
    }

    formatResult(match: string, query: string) {
        return `<button type="button" data-query="${match}|${query}" class="un-button hyperlink autocomplete-result-link titling" tabindex="-1">${match}</button>`;
    }

    generatePageLink(match: string, query: string) {
        const pageUr = (document.getElementById('listingpageurl') as HTMLInputElement).value;
        return `<a href="${pageUr}?q=${match}|${query}" class="autocomplete-result-link" tabindex="-1" data-query="${match}">${match}</a>`;
    }
}